import React from "react";
import "../css/WhatWillYouLearn.css";

import darkGunman from "../images/PISTOLERO_OSCURO.png";
import learnItems from "../utils/learnItems";
import DegradeButton from "./buttons/DegradeButton";
import LearnItem from "./cards/LearnItem";

const WhatWillYouLearn = () => {
    return (
        <div className="WhatWillYouLearn" id="learn">
            <div className="learn-container container padding">
                <h1>¿Qué Aprenderás?</h1>
                <div className="learn-content">
                    <div className="learn-image">
                        <img src={darkGunman} alt="Dark Gunman" />
                    </div>
                    <div className="learn-content-items">
                        {learnItems.map((e) => (
                            <LearnItem
                                key={e.id}
                                icon={e.icon}
                                title={e.title}
                                information={e.information}
                            />
                        ))}

                        <DegradeButton
                            name={"ÚNETE AHORA"}
                            link={true}
                            width={200}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatWillYouLearn;
